export const PROPOSAL_STATUSES = {
	PENDING: "PENDING",
	ACCEPTED: "ACCEPTED",
	REJECTED: "REJECTED",
};

export const STATUS_CONFIG = {
	PENDING: {
		label: "Pendente",
		color: "bg-amber-500/10 text-amber-400 border-amber-500/20",
	},
	ACCEPTED: {
		label: "Aceita",
		color: "bg-green-500/10 text-green-400 border-green-500/20",
	},
	REJECTED: {
		label: "Rejeitada",
		color: "bg-red-500/10 text-red-400 border-red-500/20",
	},
};
